import axios from "axios";

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_API_URL_DEV
    : process.env.REACT_APP_API_URL_PROD
})

export default instance;

// For debugging (optional)
console.log('Environment:', process.env.NODE_ENV);
console.log('API URL:', instance.defaults.baseURL);